<template>
  <div class="mytemplate">
    <van-collapse accordion @change="getClassifyContent" v-model="activeName">
      <van-collapse-item icon="/static/images/etv-folder.png" v-for="(item,index) in classify" :key="index"
                         :title="item.name">
        <div class="templist">
          <div v-if="templateList.length" style="width: 100%;min-height: calc(100% - 44px)">
            <div class="templist-con">
              <div class="tempItem" v-for="item in templateList" :key="item.id" @click="onEmploy(item.pmId)">
                <div style="width: 100%;">
                  <img src="../assets/images/icon_app.png" alt="" @error="onError(item)">
                </div>
                <div class="tempName">{{ item.mouldName }}</div>
              </div>
            </div>
          </div>
          <van-empty :description="$t('append_field.no_data')" v-else/>
        </div>
      </van-collapse-item>
    </van-collapse>

  </div>
</template>

<script>
import * as qs from "qs";

export default {
  name: "mytemplate",
  data() {
    return {
      classify: [],
      active: 0,
      templateList: [],
      pageNum: 1,
      activeName: 1
    }
  },
  async mounted() {
    await this.getClassify()
  },
  methods: {
    getClassify() {
      this.$ajax.post("/etv/selectAllMouldCategory.json").then(res => {
        if (res.data.code === 0) {
          this.classify = res.data.data
          this.getTemplate()
        }
      })
    },
    getClassifyContent(id) {
      this.active = id
      this.getTemplate()
    },
    getTemplate() {
      this.$ajax.post("/etv/selectH5Mould.json", qs.stringify({
        pageNum: this.pageNum,
        pageSize: 99999,
        resolution: "",
        mouldtypeId: this.classify[this.active].id,
      })).then(res => {
        if (res.data.code === 0) {
          this.templateList = res.data.data.list
          this.count = res.data.data.pages
        }
      })
    },
    getpage(i) {
      this.pageNum = i
      this.getTemplate()
    },
    onEmploy(id) {
      this.$router.push(`/h5Preview/${id}`)
    },
    onError(data) {
      data.sceneMould[0].scThumUrl = "../assets/images/icon_app.png"
    }

  }
}
</script>

<style scoped lang="scss">
.mytemplate {
  height: 100%;
  overflow: auto;
  background: #ffffff;
  font-size:  15px;
  display: flex;
  flex-direction: column;

  .classify {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 15px;

    span {
      padding: 5px 15px;
      margin: 5px;
      background: #cccccc;
      display: inline-block;
      border-radius: 3px;
    }

    .h5-active {
      background: #409EFF;
      color: white;
    }
  }

  .templist {
    padding: 0 7px;
    box-sizing: border-box;
    flex: 1;
    overflow: auto;

    .templist-con {
      display: flex;
      flex-wrap: wrap;
      min-height: calc(100% - 44px);

      .van-pagination {
        width: 100%;
      }
    }

    .tempItem {
      width: 33.3%;
      padding: 0 7px;
      margin-bottom: 20px;
      box-sizing: border-box;

      img {
        width: 100%;
        height: 130px;
      }

      .tempName {
        width: 100%;
        text-align: center;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
